import { apiClient } from '../api';

const orgApi = {
  getMembers: (tenantId) =>
    apiClient.get('/api/users').then(r => r.data),

  updateMemberRole: (tenantId, userId, role) =>
    apiClient.put(`/api/users/${userId}/role`, { role }).then(r => r.data),

  removeMember: (tenantId, membershipId) =>
    apiClient.delete(`/api/users/${membershipId}`).then(r => r.data),

  createInvitation: (tenantId, email, role) =>
    apiClient.post('/api/users', { email, role }).then(r => r.data),

  revokeInvitation: (tenantId, invId) =>
    apiClient.delete(`/api/invitations/${invId}`).then(r => r.data),

  resendInvitation: (tenantId, invId) =>
    apiClient.post(`/api/invitations/${invId}/resend`).then(r => r.data),

  getOrg: (tenantId) =>
    apiClient.get('/api/settings').then(r => r.data.settings),

  updateOrg: (tenantId, payload) =>
    apiClient.put('/api/settings', payload).then(r => r.data),

  deleteOrg: (tenantId) =>
    apiClient.delete(`/api/organizations/${tenantId}`).then(r => r.data),

  listWorkspaces: () =>
    apiClient.get('/api/organizations/my').then(r => r.data),

  createOrg: (name, industry) =>
    apiClient.post('/api/organizations', { name, industry }).then(r => r.data),

  switchOrg: (tenantId) =>
    apiClient.post(`/api/organizations/${tenantId}/switch`).then(r => r.data),

  getRoles: (tenantId) =>
    apiClient.get('/api/roles').then(r => r.data),

  createRole: (tenantId, payload) =>
    apiClient.post('/api/roles', payload).then(r => r.data),

  updateRole: (tenantId, roleId, payload) =>
    apiClient.put(`/api/roles/${roleId}`, payload).then(r => r.data),

  deleteRole: (tenantId, roleId) =>
    apiClient.delete(`/api/roles/${roleId}`).then(r => r.data),

  getPermissions: (tenantId) =>
    apiClient.get('/api/permissions').then(r => r.data),

  acceptInvitation: (token) =>
    apiClient.get(`/api/invitations/accept?token=${token}`).then(r => r.data),
};

export default orgApi;
